import { render, staticRenderFns } from "./SubjectOverviewNew.vue?vue&type=template&id=08df400c"
import script from "./SubjectOverviewNew.ts?vue&type=script&lang=ts&external"
export * from "./SubjectOverviewNew.ts?vue&type=script&lang=ts&external"
import style0 from "./SubjectOverviewNew.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports